import Vue from 'vue';
import { blockResolver } from '../componentResolver.service';
import { BlockType } from '@/types/apiServerContract';

import BlockRender from './helpers/BlockRender.vue';
import BlockList from './helpers/BlockList.vue';

import HeroBannerBlock from './HeroBannerBlock.vue';
import HalfWidthBlock from './HalfWidthBlock.vue';
import TextBlock from './TextBlock.vue';
import CharacterStatisticsBlock from './CharacterStatisticsBlock.vue';

blockResolver.register(BlockType.HeroBanner, HeroBannerBlock);
blockResolver.register(BlockType.HalfWidthBlock, HalfWidthBlock);
blockResolver.register(BlockType.Text, TextBlock);
blockResolver.register(BlockType.CharacterStatistics, CharacterStatisticsBlock);

Vue.component('BlockRender', BlockRender);
Vue.component('BlockList', BlockList);
